module.exports = __webpack_public_path__ + "media/images/sales/early/heading-problem-eef51c933a0acfea5f71d5e8c7d534f8.svg";